import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from '@mui/icons-material/Add';
import PostDialog from '../../../SpiderWebSite/components/PostDialog';
import { IReduxState } from '../../../store';
import AttribuerDroit from './AttributionDroit/AttribuerDroit';
import { IModule } from '../../../components/GestionFonctionnalite/Module/moduleSlice';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../util/apiClient';
import { IPersonne } from './interface';
import { IUtilisateur, addUtilisateur } from './utilisateurAppGestionInterneSlice';

interface IAddProps {
  state: IUtilisateur
  setState: (x: IUtilisateur) => void
  rightsChecked: any
  setRightsChecked: (x: any) => void
}


const AddUser = (props: IAddProps) => {

  //props
  const { state, setState, rightsChecked, setRightsChecked } = props
  // console.log("🚀 ~ file: Add.tsx:33 ~ AddUser ~ rightsChecked:", rightsChecked)

  //redux
  const { typeUtilisateurs, personnes, agents } = useSelector((state: IReduxState) => state.utilisateurAppGestionInterne);


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setState({ ...state, [name]: value })
  }

  const getAgent = (idPersonne: number) => {
    return personnes?.find(p => p.idPersonne === idPersonne)
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
      >
        <Grid item md={4} xs={12} sm={4}>
          <Grid
            container
            spacing={2}
          >

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idPersonne"
                label="Selectionner une personne"
                value={state.idPersonne}
                onChange={handleInputChange}
              >
                {agents.map((option) => (
                  <MenuItem key={option.idPersonne} value={option.idPersonne}>
                    {`${getAgent(option.idPersonne)?.nom} ${getAgent(option.idPersonne)?.prenom}`}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idTypeUtilisateur"
                label="Type utilisateur"
                value={state.idTypeUtilisateur}
                onChange={handleInputChange}
              >
                {typeUtilisateurs.map((option) => (
                  <MenuItem key={option.idTypeUtilisateur} value={option.idTypeUtilisateur}>
                    {option.libTypeUtilisateur}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                fullWidth
                size="small"
                name="email"
                label="Email"
                value={state.email}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={8} md={8}>
          {
            state.idTypeUtilisateur && state.idTypeUtilisateur !== 1 &&
            <AttribuerDroit
              rightsChecked={rightsChecked}
              setRightsChecked={setRightsChecked}
            />
            // <AttribuerDroit
            //   rightsChecked={rightsChecked}
            //   setRightsChecked={setRightsChecked}
            // />
          }
        </Grid>

      </Grid>
    </Box>
  );
};





export interface IAddUser {
  idTypeUtilisateur: number | null;
  nomUtilisateur: string;
}

export const initialState: IUtilisateur = {
  idPersonne: null,
  idTypeUtilisateur: null,
  email: ""
}


const DialogAdd = () => {

  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [state, setState] = useState<IUtilisateur>(initialState)
  const [rightsChecked, setRightsChecked] = React.useState<any>([]);

  //Ouvrir la boite de dialog 
  const onClose = () => {
    setOpen(false)
  }

  //Fermer la boite de dialog
  const handleOpenDialog = () => {
    setOpen(true)
  }

  const handleSave = async (e: any) => {
    e.preventDefault()
    try {
      setAddLoading(true)
      const apiPayload = {
        user: state,
        rights: rightsChecked
      }
      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/adduserandhisrights", apiPayload)
      if (res.status === 1) {
        dispatch(addUtilisateur(res.data))
      } else {
        console.log("status !==1")
      }
    } catch (error) {
      console.log("🚀 ~ file: Add.tsx:155 ~ handleSave ~ error:", error)
    } finally {
      setAddLoading(false)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={<AddUser
        state={state}
        setState={setState}
        rightsChecked={rightsChecked}
        setRightsChecked={setRightsChecked}
      />}
      actionFunc={handleSave}
      title="Ajout d'utilisateur"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



